// @flow
import { connect, Provider } from 'react-redux';
import _includes from 'lodash/includes';
import { stylesheet } from 'typestyle';

import type { RailsContextType } from '@types/misc';

import SaveForLaterPopup from '@components/popups/cart/SaveForLaterPopup';

type PropsType = {
  hideOnInitialRender: boolean,
  display: boolean,
  itemId: string,
  onLinkClick: Function
};

type StateType = {
  display: boolean,
  displayIcon: boolean,
  displayPopup: boolean
};

class SaveForLaterLink extends React.Component<PropsType, StateType> {
  state = {
    display: !this.props.hideOnInitialRender,
    displayIcon: false,
    displayPopup: false
  };

  componentWillReceiveProps = nextProps => {
    this.setState({ display: nextProps.display });
  };

  showIcon = () => {
    this.setState({
      displayIcon: true
    });
  };

  hideIcon = () => {
    this.setState({
      displayIcon: false
    });
  };

  togglePopup = () => {
    this.setState(prevState => {
      return {
        displayPopup: !prevState.displayPopup,
        displayIcon: !prevState.displayIcon
      };
    });
  };

  hidePopupAndIcon = () => {
    this.setState({
      displayPopup: false,
      displayIcon: false
    });
  };

  render() {
    if (!this.state.display) {
      return null;
    }

    return (
      <div onMouseEnter={this.showIcon} onMouseLeave={this.hideIcon}>
        <SaveForLaterPopup
          show={this.state.displayIcon || this.state.displayPopup}
          showPopup={this.state.displayPopup}
          togglePopup={this.togglePopup}
          hidePopupAndIcon={this.hidePopupAndIcon}
        />
        <a onClick={this.props.onLinkClick}>save for later</a>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    display: !_includes(state.diamondComparison.ids, ownProps.itemId),
    hideOnInitialRender: ownProps.hideOnInitialRender,
    itemId: ownProps.itemId
  };
}

function mapDispatchToProps(dispatch: Function, ownProps) {
  return {
    onLinkClick: function(e) {
      e.preventDefault();
      dispatch({
        type: 'TOGGLE_DIAMOND_FOR_COMPARISON',
        item: ownProps.itemId
      });
    }
  };
}

const ConnectedSaveForLaterLink = connect(
  mapStateToProps,
  mapDispatchToProps
)(SaveForLaterLink);

export default (props: PropsType, railsContext: RailsContextType) => {
  const store = ReactOnRails.getStore('SharedReduxStore');

  return (
    <Provider store={store}>
      <ConnectedSaveForLaterLink {...{ ...props, railsContext }} />
    </Provider>
  );
};
